export const RenderHTML = ({ html, replace = {} }) => {
	for (let key in replace) {
		html = html.replace(key, replace[key])
	}

	return <span dangerouslySetInnerHTML={{ __html: html }} />
}

export const getUrl = () => (window.location != window.parent.location ? document.referrer : document.location.href)
